import { useLayoutEffect, useState } from 'react';

const MARGIN = 24;

/**
 * Keeps the fixed bar centered over the card and MARGIN px above the footer, or above the
 * bottom of the screen while the footer is out of view
 * @param {Object} barRef Ref of the bar container, rendered inside the card
 * @returns {Object} left and bottom, in px
 */
const useBarPosition = (barRef) => {
  const [position, setPosition] = useState(null);

  useLayoutEffect(() => {
    const card = barRef.current?.parentElement;

    if (!card) return undefined;

    const updatePosition = () => {
      const cardRect = card.getBoundingClientRect();
      const footerTop = document.querySelector('.footer')?.getBoundingClientRect().top;
      const visibleBottom = Math.min(footerTop ?? window.innerHeight, window.innerHeight);

      setPosition({
        left: cardRect.left + cardRect.width / 2,
        bottom: window.innerHeight - visibleBottom + MARGIN,
      });
    };

    updatePosition();

    const resizeObserver = new ResizeObserver(updatePosition);
    resizeObserver.observe(card);
    resizeObserver.observe(document.body);
    window.addEventListener('scroll', updatePosition, true);
    window.addEventListener('resize', updatePosition);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener('scroll', updatePosition, true);
      window.removeEventListener('resize', updatePosition);
    };
  }, [barRef]);

  return position;
};

export default useBarPosition;
